<!--<div class="row align-items-center p-b-10">
  <div class="col-sm-12 col-lg-12">
    <div class="d-flex align-items-center flexmob">
      <div class="m-l-10 d-flex align-items-center">
        <div>
          <button mat-fab style="width: 50px;height: 50px;border-radius: 20%;" class="brandbglight">
            <i-tabler name="file-export" class="icon-28" style="line-height: 30px !important"></i-tabler>
          </button>
        </div>
        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Final Accounts
          </h4>
        </div>
      </div>
    </div>
  </div>
</div>-->

<div class="row align-items-center m-b-10">
  <div class="col-sm-12 col-lg-6">
    <div class="d-flex align-items-center flexmob">
      <div class="d-flex align-items-center f-s-14 text-black-25 border-right p-r-10 cursor-pointer f-w-600" (click)="backToCharityOverView()">
        <!--<i-tabler class="icon-20 m-r-4 m-t-0 anim" name="arrow-left"></i-tabler> Back to Charity Overview-->
        <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-left"></i-tabler> Back to Charity Overview
      </div>
      <div class="m-l-10 d-flex align-items-center">

        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Final Accounts
          </h4>
        </div>
      </div>
    </div>
  </div>
  <!--<div class="col-sm-12 col-lg-6 text-right">-->
  <div class="col-sm-12 col-lg-6">
    <div class="d-flex justify-content-end">
      <div class="p-8" style="background-color: #fff; border-radius:10px;">
        <button mat-flat-button class="bg-none m-r-10" [disabled]="!UserRoleAccess?.m1ExportorDownload" (click)="this.ExportasPDFandIXBRL('ExportasPDF', 'ForPDFviwer',template,'Preview')">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-10" name="eye"></i-tabler>Preview
          </div>
        </button>
        <button mat-flat-button color="primary" class="bg-none import" (click)="openExport(templateExport)" [disabled]="!UserRoleAccess?.m1ExportorDownload">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-10" name="upload"></i-tabler> Export
          </div>
        </button>
        <!--<button mat-flat-button color="primary" style="height: 30px;" (click)="sendMailTemplate(emailtemplate)">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-10" name="mail"></i-tabler> Send Mail
          </div>
        </button>-->
      </div>
    </div>
  </div>
</div>

<!--Period Finalised & Ready to Submit-->
<ng-template #otherUI>
  <div *ngIf="apFinalised " class="col-md-12 col-lg-12 m-t-20 p-0">
    <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #fed7aa !important; background: #fff7ed; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
      <mat-card-content class="p-y-20">
        <div class="row align-items-center">
          <div class="col-md-8">
            <div class="d-flex align-items-center">
              <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #ff9f1f; background: #ffedd5; display: flex; align-items: center; justify-content: center;" class="text-warning">
                <i-tabler name="lock" class="icon-24" style="color: #ea580c;"></i-tabler>
              </div>
              <!--<div>
                <h4>Period Finalised & Ready to Submit</h4>
                <p class="m-y-2">Accounts have been finalised and are now ready to submit</p>
              </div>-->
              <div class="m-l-10">
                <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">
                  Period Finalised & Ready to Submit
                </h4>
                <div>
                  <h5 class="f-s-14 f-w-600 m-x-4">Accounts have been finalised and are now ready to submit  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right lockUnlockRes">
            <div class="d-flex gap-10 justify-content-end custom-cards-trial">
              <button mat-flat-button class="rounded-5" style="border: 1px solid #fdba74; background:#fff;" (click)="UnfreezeAP()">
                <div class="d-flex text-black">
                  <i-tabler class="icon-20 m-r-4 m-t-0" name="lock-open" style="color: #c2410c;"></i-tabler><span class="f-s-14" style="color: #c2410c;">Unlock</span>
                </div>
              </button>
              <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="gotoSubmissions()">
                <div class="d-flex text-black">
                  <!--<i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler>--><span class="f-s-14 text-white">Submit</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
<!--Period Finalised & Ready to Submit ends-->
<!--Period Submitted-->
<div *ngIf="apFinalised &&  this.UserRoleAccess?.currentAPSubmitStatus != 'Not Submit' && this.UserRoleAccess?.currentAPSubmitStatus  !== 'Failed' ; else otherUI" class="col-md-12 col-lg-12 p-0 m-t-20">
  <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #A7F3D0 !important; background: #ECFDF5; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
    <mat-card-content class="p-y-20">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="d-flex align-items-center">
            <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #9ee9c2; background: #d1fae5; display: flex; align-items: center; justify-content: center; " class="text-warning">
              <i-tabler name="circle-check" class="icon-30" style="color: #059669;"></i-tabler>
            </div>
            <div class="m-l-10">
              <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">
                Period Submitted
              </h4>
              <div>
                <h5 class="f-s-14 f-w-600 m-x-4">Submitted to Companies House on {{this.UserRoleAccess?.currentAPSubmitDate}}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-right lockUnlockRes">
          <div class="d-flex gap-10 justify-content-end custom-cards-trial">
            <button mat-flat-button color="primary" class="rounded-5 successBtn" (click)="UnlockandAmend()">
              <div class="d-flex">
                <i-tabler class="icon-20 m-r-4 m-t-0" name="reload"></i-tabler><span class="f-s-14">Unlock & Amend Accounts</span>
              </div>
            </button>
          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>
<!--Ends Period Submitted-->


<div class="container-fluid">

  <div class="row m-t-20 ">
    <div class="col-lg-5 m-b-20">
      <mat-card style="border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;" class="h-100">
        <mat-card-content>
          <div class="row card-row p-b-16">
            <div class="col-lg-12">
              <h5 class="f-s-18 f-w-600 heading-text-clr">Account Sections</h5>
            </div>
          </div>
          <div class="row card-row p-y-16 p-t-32 b-t-1">
            <div class="col-lg-6">
              <h5 class="f-s-14 f-w-500">Basic Information <span class="text-danger">* </span></h5>
            </div>
            <div class="col-lg-6 text-right">
              <div class="d-flex align-items-center justify-content-end">
                <button mat-flat-button color="primary" class="bg-success-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="circle-check" class="icon-16 m-t-2 m-r-10 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> Completed</span>
                </button>

                <button mat-flat-button color="primary" class="bg-edit-btn text-primary" style="height: 30px;" routerLink="/basicinformation" [disabled]="!UserRoleAccess?.m1Edit||apFinalised">
                  <span class=""> Edit </span>
                </button>
              </div>
            </div>
          </div>
          <div class="row card-row p-y-16">
            <div class="col-lg-6">
              <h5 class="f-s-14 f-w-500">
                Trial Balance <span class="text-danger">* </span>
              </h5>
            </div>
            <div class="col-lg-6 text-right">
              <div class="d-flex align-items-center justify-content-end">
                <button mat-flat-button color="primary" *ngIf="TrailBalanceStatus=='Completed'" class="bg-success-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="circle-check" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class="">{{TrailBalanceStatus}}</span>
                </button>
                <button mat-flat-button color="primary" *ngIf="TrailBalanceStatus=='Incompleted'" class="bg-warning-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="alert-square-rounded" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> Incomplete </span>
                </button>

                <button mat-flat-button color="primary" routerLink="/trialbalance" class="bg-edit-btn text-primary" style="height: 30px;" [disabled]="!UserRoleAccess?.m1Edit||apFinalised">
                  <span class=""> Edit </span>
                </button>
              </div>
            </div>
          </div>
          <div class="row card-row p-y-16" *ngIf="accounting_Method =='Accruals (FRS 102 SORP)'">
            <div class="col-lg-6">
              <h5 class="f-s-14 f-w-500">
                Statement of Financial Activities <span class="text-danger">* </span>
              </h5>
            </div>
            <div class="col-lg-6 text-right">
              <div class="d-flex align-items-center justify-content-end">
                <button mat-flat-button color="primary" *ngIf="SOFAStatus=='Completed'&& sofaRecordStatus" class="bg-success-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="circle-check" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> Completed </span>
                </button>
                <button mat-flat-button color="primary" *ngIf="SOFAStatus=='Incompleted'" class="bg-warning-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="alert-square-rounded" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> Incomplete </span>
                </button>
                <button mat-flat-button color="primary" *ngIf="SOFAStatus=='Completed'&& !sofaRecordStatus" class="bg-norecord-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="alert-square-rounded" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> No record found </span>
                </button>

                <button mat-flat-button color="primary" routerLink="/financialactivities" class="bg-edit-btn text-primary" style="height: 30px;" [disabled]="!UserRoleAccess?.m1Edit||apFinalised">
                  <span class=""> Edit </span>
                </button>
              </div>
            </div>
          </div>
          <div class="row card-row p-y-16" *ngIf="accounting_Method =='Accruals (FRS 102 SORP)'">
            <div class="col-lg-6">
              <h5 class="f-s-14 f-w-500">
                Balance Sheet <span class="text-danger">* </span>
              </h5>
            </div>
            <div class="col-lg-6 text-right">
              <div class="d-flex align-items-center justify-content-end">
                <button mat-flat-button color="primary" *ngIf="BalanceSheetStatus=='Incompleted'" class="bg-warning-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="alert-square-rounded" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> Incomplete </span>
                </button>
                <button mat-flat-button color="primary" *ngIf="BalanceSheetStatus=='Completed'&&!balRecordStatus" class="bg-norecord-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="alert-square-rounded" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> No record found </span>
                </button>
                <button mat-flat-button color="primary" *ngIf="BalanceSheetStatus=='Completed'&& balRecordStatus" class="bg-success-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="circle-check" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> Completed </span>
                </button>

                <button mat-flat-button color="primary" routerLink="/balancesheet" class="bg-edit-btn text-primary" style="height: 30px;" [disabled]="!UserRoleAccess?.m1Edit||apFinalised">
                  <span class=""> Edit </span>
                </button>
              </div>
            </div>
          </div>

          <div class="row card-row p-y-16" *ngIf="accounting_Method !='Accruals (FRS 102 SORP)'">
            <div class="col-lg-6">
              <h5 class="f-s-14 f-w-500">
                Receipts and Payments <span class="text-danger">* </span>
              </h5>
            </div>
            <div class="col-lg-6 text-right">
              <div class="d-flex align-items-center justify-content-end">
                <button mat-flat-button color="primary" *ngIf="ReceiptsStatus=='Incompleted'" class="bg-warning-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="alert-square-rounded" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> Incomplete </span>
                </button>
                <button mat-flat-button color="primary" *ngIf="ReceiptsStatus=='Completed'&&!rpRecordStatus" class="bg-norecord-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="alert-square-rounded" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> No record found </span>
                </button>
                <button mat-flat-button color="primary" *ngIf="ReceiptsStatus=='Completed'&& rpRecordStatus" class="bg-success-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="circle-check" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> Completed </span>
                </button>

                <button mat-flat-button color="primary" routerLink="/receiptsandpayments" class="bg-edit-btn text-primary" style="height: 30px;" [disabled]="!UserRoleAccess?.m1Edit||apFinalised">
                  <span class=""> Edit </span>
                </button>
              </div>
            </div>
          </div>
          <div class="row card-row p-y-16" *ngIf="accounting_Method !='Accruals (FRS 102 SORP)'">
            <div class="col-lg-6">
              <h5 class="f-s-14 f-w-500">
                Statement of Assets and Liabilities <span class="text-danger">* </span>
              </h5>
            </div>
            <div class="col-lg-6 text-right">
              <div class="d-flex align-items-center justify-content-end">
                <button mat-flat-button color="primary" *ngIf="StatementStatus=='Completed'&& sfalRecordStatus" class="bg-success-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="circle-check" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> Completed </span>
                </button>
                <button mat-flat-button color="primary" *ngIf="StatementStatus=='Completed'&& !sfalRecordStatus" class="bg-norecord-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="alert-square-rounded" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> No record found </span>
                </button>
                <button mat-flat-button color="primary" *ngIf="StatementStatus=='Incompleted'" class="bg-warning-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="alert-square-rounded" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> Incomplete </span>
                </button>

                <button mat-flat-button color="primary" routerLink="/assets-statements" class="bg-edit-btn text-primary" style="height: 30px;" [disabled]="!UserRoleAccess?.m1Edit||apFinalised">
                  <span class=""> Edit </span>
                </button>
              </div>
            </div>
          </div>
          <div class="row card-row p-y-16">
            <div class="col-lg-6">
              <h5 class="f-s-14 f-w-500">
                Notes <span class="text-danger">* </span>
              </h5>
            </div>
            <div class="col-lg-6 text-right" style="position: relative">
              <div class="d-flex align-items-center justify-content-end">
                <button mat-flat-button color="primary" *ngIf="!notecompleted" class="bg-success-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="circle-check" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> Completed </span>
                </button>
                <button mat-flat-button color="primary"
                        *ngIf="notecompleted"
                        class="onHover-tooltip bg-warning-status-btn text-primary m-r-10"
                        style="height: 30px; position: relative;">

                  <i-tabler name="alert-square-rounded" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span> Incomplete </span>
                  <div class="custom-tooltipbox" *ngIf="notesArray?.length != 0 && notesArray != null  ">

                    <div class="tooltip-arrow"></div>
                    <mat-card class="tooltip-card b-0">
                      <mat-card-content class="p-16">
                        <div class="chat-bubble">

                          <div style="max-height: 220px; overflow-y: auto;">
                            <div *ngFor="let note of notesArray" class="d-flex align-items-center justify-content-between table-cust b-b-1">
                              <div class="">
                                <h4 class="f-s-12 p-0 m-0">{{note.noteName |addSpaceBeforeNumber }}</h4>
                              </div>
                              <div class="d-flex align-items-center justify-content-end">
                                <button mat-flat-button color="primary" class="bg-warning-status-btn text-primary m-r-10" style="height: 30px;">
                                  <i-tabler name="circle-check" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                                  <span class=""> {{note.accStatus}}   </span>
                                </button>
                                <button mat-flat-button color="primary" class="bg-edit-btn text-primary" style="height: 30px;" (click)="notenavigation('/charity/notes/' + note.note.toLowerCase())" [disabled]="!UserRoleAccess?.m1Edit||apFinalised">
                                  <span class=""> Edit </span>
                                </button>
                              </div>
                            </div>
                          </div>


                        </div>
                      </mat-card-content>
                    </mat-card>

                  </div>
                </button>


                <button mat-flat-button color="primary" class="bg-edit-btn text-primary" style="height: 30px;" routerLink="/Accountnotes" [disabled]="!UserRoleAccess?.m1Edit||apFinalised">
                  <span class=""> Edit </span>
                </button>
              </div>
            </div>
          </div>
          <!--<div class="row card-row p-y-16">
            <div class="col-lg-6">
              <h5 class="f-s-14 f-w-500">
                Director's Report
              </h5>
            </div>
            <div class="col-lg-6 text-right">
              <div class="d-flex align-items-center justify-content-end">
                <button mat-flat-button color="primary" class="bg-success-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="circle-check" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> Completed </span>
                </button>

                <button mat-flat-button color="primary" class="bg-edit-btn text-primary" style="height: 30px;">
                  <span class=""> Edit </span>
                </button>
              </div>
            </div>
          </div>-->
          @if (report_Type === 'Auditor') {
          <div class="row card-row p-y-16">
            <div class="col-lg-6">
              <h5 class="f-s-14 f-w-500">
                Trustees' Report<span class="text-danger">*</span>
              </h5>
            </div>

            <div class="col-lg-6 text-right">
              <div class="d-flex align-items-center justify-content-end">
                @if (TrusteeAnnualReportStatus === 'Completed' || StatementofTrusteesResponsibility === 'Completed') {
                <button mat-flat-button color="primary" class="bg-success-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="circle-check" class="icon-16 m-t-2 m-r-10"></i-tabler>
                  <span>Completed</span>
                </button>
                } @else {
                <button mat-flat-button color="primary" class="bg-warning-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="alert-square-rounded" class="icon-16 m-t-2 m-r-10"></i-tabler>
                  <span>Incompleted</span>
                </button>
                }

                <button mat-flat-button color="primary" class="bg-edit-btn text-primary" style="height: 30px;"
                        routerLink="/trusteeannualreport"
                        [disabled]="!UserRoleAccess?.m1Edit || apFinalised">
                  <span>Edit</span>
                </button>
              </div>
            </div>
          </div>
          } @else if (report_Type === 'Independent Examiner' && (TrusteeAnnualReportStatus === 'Completed' || StatementofTrusteesResponsibility === 'Completed')) {
          <div class="row card-row p-y-16">
            <div class="col-lg-6">
              <h5 class="f-s-14 f-w-500">
                Trustees' Report
              </h5>
            </div>

            <div class="col-lg-6 text-right">
              <div class="d-flex align-items-center justify-content-end">
                <button mat-flat-button color="primary" class="bg-success-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="circle-check" class="icon-16 m-t-2 m-r-10"></i-tabler>
                  <span>Completed</span>
                </button>

                <button mat-flat-button color="primary" class="bg-edit-btn text-primary" style="height: 30px;"
                        routerLink="/trusteeannualreport"
                        [disabled]="!UserRoleAccess?.m1Edit || apFinalised">
                  <span>Edit</span>
                </button>
              </div>
            </div>
          </div>
          }

          <div class="row card-row p-y-16" *ngIf="report_Type=='Auditor'">
            <div class="col-lg-6">
              <h5 class="f-s-14 f-w-500">
                Auditor's Report <span class="text-danger">* </span>
              </h5>
            </div>
            <div class="col-lg-6 text-right">
              <div class="d-flex align-items-center justify-content-end">
                <button mat-flat-button *ngIf="AuditorStatus=='Completed'" color="primary" class="bg-success-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="circle-check" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class="">{{AuditorStatus}} </span>
                </button>
                <button mat-flat-button color="primary" *ngIf="AuditorStatus=='Incompleted'" class="bg-warning-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="alert-square-rounded" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> Incomplete </span>
                </button>

                <button mat-flat-button color="primary" class="bg-edit-btn text-primary" style="height: 30px;" routerLink="/audit-report" [disabled]="!UserRoleAccess?.m1Edit||apFinalised">
                  <span class=""> Edit </span>
                </button>
              </div>
            </div>
          </div>
          <div class="row card-row p-y-16" *ngIf="report_Type == 'Independent Examiner'">
            <div class="col-lg-6">
              <h5 class="f-s-14 f-w-500">
                Independent Examiner's Report <span class="text-danger">* </span>
              </h5>
            </div>
            <div class="col-lg-6 text-right">
              <div class="d-flex align-items-center justify-content-end">
                <button mat-flat-button *ngIf="IndependentExaminationStatus=='Completed'" color="primary" class="bg-success-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="circle-check" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> {{IndependentExaminationStatus}} </span>
                </button>
                <button mat-flat-button color="primary" *ngIf="IndependentExaminationStatus=='Incompleted'" class="bg-warning-status-btn text-primary m-r-10" style="height: 30px;">
                  <i-tabler name="alert-square-rounded" class="icon-16 m-t-2 m-r-10" style="line-height: 16px !important"></i-tabler>
                  <span class=""> Incomplete</span>
                </button>

                <button mat-flat-button color="primary" class="bg-edit-btn text-primary" style="height: 30px;" routerLink="/independentexaminerreport" [disabled]="!UserRoleAccess?.m1Edit||apFinalised">
                  <span class=""> Edit </span>
                </button>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-lg-7 m-b-20" *ngIf="this.Account_Type!='Amended'">
      <mat-card style="border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important; margin-bottom: 0px !important;" class="h-100">
        <mat-card-content>
          <form [formGroup]="ApprovalForm">
            <div class="row card-row p-b-16">
              <div class="col-lg-12">
                <h5 class="f-s-18 f-w-600 heading-text-clr">Approval of the Statutory Accounts</h5>
              </div>
            </div>
            <div class="row p-y-16 b-t-1">
              <div class="col-lg-6">
                <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                  <div class="d-flex align-items-center">
                    <i-tabler class="icon-20 m-r-10 primary-color-dark" name="calendar"></i-tabler>
                    <h5 class="f-w-500 f-s-14">
                      Approval Date <span class="text-danger"> *</span>
                    </h5>
                  </div>
                </mat-label>
                <mat-form-field appearance="outline" class="w-100 no-subscript">
                  <input matInput formControlName="approvalDate" [matDatepicker]="picker" (dateChange)="checkdate($event)" (blur)="checkdate($event)" (input)="validate()" placeholder="dd/mm/yyyy" appTextMaskDate />
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <!--<mat-error *ngIf="tarDetails.approvalDate_SecA &&(tarDetails.approvalDate_SecA < startDate || tarDetails.approvalDate_SecA > today)">
                  Approval Date should be on or between Accounting Period Start and Today's Date
                </mat-error>-->
                <mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="ApprovalForm.get('approvalDate')?.hasError('Invalid') ">
                  Approval Date is invalid
                </mat-error>
                <mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="ApprovalForm.get('approvalDate')?.hasError('required') ">
                  Approval Date is required
                </mat-error>
                <mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="ApprovalForm.get('approvalDate')?.hasError('Dateexceed') ">
                  Approval Date should be on or between Accounting Period Start and Today's Date
                </mat-error>
              </div>
              <div class="col-lg-6">
                <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                  <div class="d-flex align-items-center">
                    <i-tabler class="icon-20 m-r-10 primary-color-dark" name="user"></i-tabler>
                    <h5 class="f-w-500 f-s-14">
                      Name of Approver <span class="text-danger"> *</span>
                    </h5>
                  </div>
                </mat-label>
                <div class="text-right" *ngIf="this.accounting_Method != 'Accruals (FRS 102 SORP)'">
                  <mat-form-field appearance="outline" class="w-100 no-subscript">
                    <mat-select #approvalSelect formControlName="approvalName" placeholder="Select Approver" (selectionChange)="onTrusteeChange($event);" class="text-left" multiple>
                      <mat-option (click)="modalAddTrustee(template2,input)" class="lightBtn no-checkbox">
                        <div class="d-flex thmeColor"><i-tabler class="icon-18 m-r-4" name="plus"></i-tabler>  <span class="hidemenutext"> Trustee</span></div>
                      </mat-option>
                      <mat-option *ngFor="let data of trustee" class="w-100 full-wid" [value]="data.trustee_Id">
                        {{data.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-error style="text-align: left; padding-left: 14px; !important" *ngIf="ApprovalForm.get('approvalName')?.hasError('required') ">
                    Select a Approver Name
                  </mat-error>
                  <mat-error style="text-align: left; padding-left: 14px; !important" *ngIf="this.ApprovalForm.get('approvalName')?.hasError('maxlimit')">
                    Name of Approver cannot be more than 2 trustees
                  </mat-error>
                </div>
                <div class="text-right" *ngIf="this.accounting_Method == 'Accruals (FRS 102 SORP)'">
                  <mat-form-field appearance="outline" class="w-100 no-subscript">
                    <mat-select formControlName="approvalName" placeholder="Select Approver" (selectionChange)="onTrusteeChange($event)" class="text-left">
                      <mat-option (click)="modalAddTrustee(template2,input)" class="lightBtn">
                        <div class="d-flex thmeColor"><i-tabler class="icon-18 m-r-4" name="plus"></i-tabler>  <span class="hidemenutext"> Trustee</span></div>
                      </mat-option>

                      <mat-option *ngFor="let data of trustee" class="w-100 full-wid" [value]="data.trustee_Id">
                        {{data.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-error style="text-align: left; padding-left: 14px; !important" *ngIf="ApprovalForm.get('approvalName')?.hasError('required') ">
                    Select a Approver Name
                  </mat-error>
                </div>
              </div>
              <!--<div class="col-lg-6">
              <mat-form-field appearance="outline" class="w-100 no-subscript">
                <input matInput formControlName="approvalDate" [matDatepicker]="picker" (dateChange)="checkdate($event)" (blur)="checkdate($event)" (input)="validate()" placeholder="dd/mm/yyyy" appTextMaskDate />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>-->
              <!--<mat-error *ngIf="tarDetails.approvalDate_SecA &&(tarDetails.approvalDate_SecA < startDate || tarDetails.approvalDate_SecA > today)">
                Approval Date should be on or between Accounting Period Start and Today's Date
              </mat-error>-->
              <!--<mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="ApprovalForm.get('approvalDate')?.hasError('Invalid') ">
                  Approval Date is invalid
                </mat-error>
                <mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="ApprovalForm.get('approvalDate')?.hasError('required') ">
                  Approval Date is required
                </mat-error>
                <mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="ApprovalForm.get('approvalDate')?.hasError('Dateexceed') ">
                  Approval Date should be on or between Accounting Period Start and Today's Date
                </mat-error>
              </div>-->
            </div>
          </form>
          <div class="col-12 p-x-0">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="f-s-15 f-w-600 heading-text-clr">
                Approval Statement
              </h4>
              <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;" (click)="setdefault()">
                <span class=""> Default Statement </span>
              </button>
            </div>
          </div>
          <div class="w-100">
            <!--<div class="NgxEditor__Wrapper" style="min-height: 300px;">
              <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" class=""> </ngx-editor-menu>
              <ngx-editor [editor]="editor"  (ngModelChange)="handleEditorInput($event)"  class="f-s-14 p-10" [innerHTML]="statement" [disabled]="false"></ngx-editor>
            </div>-->
            <mat-card-content class="m-t-0 p-x-0 p-t-4" [ngClass]="apFinalised ? 'disable' : ''">
              <!--<div class="NgxEditor__Wrapper" style="min-height: 300px;">-->
              <div class="NgxEditor__Wrapper" style="min-height: 230px;">
                <ngx-editor-menu [editor]="editor" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                <ngx-editor [editor]="editor" [disabled]="apFinalised" [(ngModel)]="Descriptionstring" (ngModelChange)="handleEditorInput($event,'approval');" [placeholder]="'Type here...'"></ngx-editor>
              </div>
            </mat-card-content>
          </div>

        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-lg-7 m-b-20" *ngIf="this.Account_Type=='Amended'">
      <mat-card style="border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important; margin-bottom: 0px !important;" class="h-100">
        <mat-card-content>
          <form [formGroup]="ApprovalForm">
            <div class="row card-row p-b-16">
              <div class="col-lg-12">
                <h5 class="f-s-18 f-w-600 heading-text-clr">Revised of the Statutory Accounts</h5>
              </div>
            </div>
            <div class="row p-y-16 b-t-1">
              <div class="col-lg-6">
                <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                  <div class="d-flex align-items-center">
                    <i-tabler class="icon-20 m-r-10 primary-color-dark" name="calendar"></i-tabler>
                    <h5 class="f-w-500 f-s-14">
                      Revised  Approval Date <span class="text-danger"> *</span>
                    </h5>
                  </div>
                </mat-label>
                <mat-form-field appearance="outline" class="w-100 no-subscript">
                  <input matInput formControlName="approvalDate" [matDatepicker]="picker" (dateChange)="checkdate($event)" (blur)="checkdate($event)" (input)="validate()" placeholder="dd/mm/yyyy" appTextMaskDate />
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <!--<mat-error *ngIf="tarDetails.approvalDate_SecA &&(tarDetails.approvalDate_SecA < startDate || tarDetails.approvalDate_SecA > today)">
                  Approval Date should be on or between Accounting Period Start and Today's Date
                </mat-error>-->
                <mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="ApprovalForm.get('approvalDate')?.hasError('Invalid') ">
                  Revised Date is invalid
                </mat-error>
                <mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="ApprovalForm.get('approvalDate')?.hasError('required') ">
                  Revised Date is required
                </mat-error>
                <mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="ApprovalForm.get('approvalDate')?.hasError('Dateexceed') ">
                  Revised Date should be on or between Accounting Period Start and Today's Date
                </mat-error>
              </div>
              <div class="col-lg-6">
                <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                  <div class="d-flex align-items-center">
                    <i-tabler class="icon-20 m-r-10 primary-color-dark" name="user"></i-tabler>
                    <h5 class="f-w-500 f-s-14">
                      Name of Approver <span class="text-danger"> *</span>
                    </h5>
                  </div>
                </mat-label>
                <div class="text-right" *ngIf="this.accounting_Method != 'Accruals (FRS 102 SORP)'">
                  <mat-form-field appearance="outline" class="w-100 no-subscript">
                    <mat-select #approvalSelect formControlName="approvalName" placeholder="Select Approver" (selectionChange)="onTrusteeChange($event);" class="text-left" multiple>
                      <mat-option (click)="modalAddTrustee(template2,input)" class="lightBtn no-checkbox">
                        <div class="d-flex thmeColor"><i-tabler class="icon-18 m-r-4" name="plus"></i-tabler>  <span class="hidemenutext"> Trustee</span></div>
                      </mat-option>
                      <mat-option *ngFor="let data of trustee" class="w-100 full-wid" [value]="data.trustee_Id">
                        {{data.name}}
                        <!--<div class="row">
                          <div class="col-6">Trustee Name</div>
                          <div class="col-6 text-right">Chairman</div>
                        </div>-->
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <!--<mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="ApprovalForm.get('approvalName')?.hasError('required') ">-->
                  <mat-error style="text-align: left; padding-left: 14px; !important" *ngIf="ApprovalForm.get('approvalName')?.hasError('required') ">
                    Select a Approver Name
                  </mat-error>
                  <!--<mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="this.ApprovalForm.get('approvalName')?.hasError('maxlimit')">-->
                  <mat-error style="text-align: left; padding-left: 14px; !important" *ngIf="this.ApprovalForm.get('approvalName')?.hasError('maxlimit')">
                    max 2 options
                  </mat-error>
                </div>
                <div class="text-right" *ngIf="this.accounting_Method == 'Accruals (FRS 102 SORP)'">
                  <mat-form-field appearance="outline" class="w-100 no-subscript">
                    <mat-select formControlName="approvalName" placeholder="Select Approver" (selectionChange)="onTrusteeChange($event)" class="text-left">
                      <mat-option (click)="modalAddTrustee(template2,input)" class="lightBtn no-checkbox">
                        <div class="d-flex thmeColor"><i-tabler class="icon-18 m-r-4" name="plus"></i-tabler>  <span class="hidemenutext"> Trustee</span></div>
                      </mat-option>
                      <mat-option *ngFor="let data of trustee" class="w-100 full-wid" [value]="data.trustee_Id">
                        {{data.name}}
                        <!--<div class="row">
                          <div class="col-6">Trustee Name</div>
                          <div class="col-6 text-right">Chairman</div>
                        </div>-->
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="ApprovalForm.get('approvalName')?.hasError('required') ">
                    Select a Approver Name
                  </mat-error>
                </div>
              </div>
              <!--<div class="col-lg-6">
              <mat-form-field appearance="outline" class="w-100 no-subscript">
                <input matInput formControlName="approvalDate" [matDatepicker]="picker" (dateChange)="checkdate($event)" (blur)="checkdate($event)" (input)="validate()" placeholder="dd/mm/yyyy" appTextMaskDate />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>-->
              <!--<mat-error *ngIf="tarDetails.approvalDate_SecA &&(tarDetails.approvalDate_SecA < startDate || tarDetails.approvalDate_SecA > today)">
                Approval Date should be on or between Accounting Period Start and Today's Date
              </mat-error>-->
              <!--<mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="ApprovalForm.get('approvalDate')?.hasError('Invalid') ">
                  Approval Date is invalid
                </mat-error>
                <mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="ApprovalForm.get('approvalDate')?.hasError('required') ">
                  Approval Date is required
                </mat-error>
                <mat-error style="text-align: left; padding-left: inherit; !important" *ngIf="ApprovalForm.get('approvalDate')?.hasError('Dateexceed') ">
                  Approval Date should be on or between Accounting Period Start and Today's Date
                </mat-error>
              </div>-->
            </div>
          </form>
          <div class="col-12 p-x-0">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="f-s-15 f-w-600 heading-text-clr">
                Approval Statement
              </h4>
              <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;" (click)="setdefault()">
                <span class=""> Default Statement </span>
              </button>
            </div>
          </div>
          <div class="w-100">
            <!--<div class="NgxEditor__Wrapper" style="min-height: 300px;">
              <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" class=""> </ngx-editor-menu>
              <ngx-editor [editor]="editor"  (ngModelChange)="handleEditorInput($event)"  class="f-s-14 p-10" [innerHTML]="statement" [disabled]="false"></ngx-editor>
            </div>-->
            <mat-card-content class="m-t-0 p-x-0 p-t-4" [ngClass]="apFinalised ? 'disable' : ''">
              <!--<div class="NgxEditor__Wrapper" style="min-height: 300px;">-->
              <div class="NgxEditor__Wrapper" style="min-height: 230px;">
                <ngx-editor-menu [editor]="editor" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                <ngx-editor [editor]="editor" [disabled]="apFinalised" [(ngModel)]="Descriptionstring" (ngModelChange)="handleEditorInput($event,'approval');" [placeholder]="'Type here...'"></ngx-editor>
              </div>
            </mat-card-content>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  @if (isDormant) {
  <mat-card style="border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
    <mat-card-content>


      <div>
        <div class="col-12 p-x-0">
          <div class="d-flex justify-content-between align-items-center">
            <h4 class="f-s-15 f-w-600 heading-text-clr">
              Statement that company is entitled to exemption from audit under Section 480 Companies Act 2006 relating to Dormant Companies
            </h4>
            <button mat-flat-button color="primary" class="bg-none text-primary" style="height: 30px;" (click)="setdefault2()">
              <span class=""> Default Statement </span>
            </button>
          </div>
        </div>
        <div class="w-100">
          <!--<div class="NgxEditor__Wrapper" style="min-height: 300px;">
            <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" class=""> </ngx-editor-menu>
            <ngx-editor [editor]="editor"  (ngModelChange)="handleEditorInput($event)"  class="f-s-14 p-10" [innerHTML]="statement" [disabled]="false"></ngx-editor>
          </div>-->
          <mat-card-content class="m-t-0 p-x-0 p-t-4" [ngClass]="apFinalised ? 'disable' : ''">
            <!--<div class="NgxEditor__Wrapper" style="min-height: 300px;">-->
            <div class="NgxEditor__Wrapper" style="min-height: 230px;">
              <ngx-editor-menu [editor]="editor2" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
              <ngx-editor [editor]="editor2" [disabled]="apFinalised" [(ngModel)]="DescriptionForDormantCompanies" (ngModelChange)="handleEditorInput($event,'dormant');" [placeholder]="'Type here...'"></ngx-editor>
            </div>
          </mat-card-content>
        </div>
      </div>


    </mat-card-content>
  </mat-card>
  }
  <mat-card style="border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
    <mat-card-content>

      <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>

      <div class="card p-y-0 m-t-20">
        <div class="row" *ngIf="!apFinalised">
          <div class="col-lg-6">
            <p class="f-s-14 f-w-500 m-0 p-0">
              Ready to Finalise: <span *ngIf="progress>=100"> Yes</span><span *ngIf="progress<100"> No</span>
            </p>
          </div>
          <!--&& !UserRoleAccess?.m1Create future condition-->
          <div class="col-lg-6 text-right">
            <button mat-flat-button class="bg-success rounded-5 m-l-16" (click)="FinaliseandClose()" [disabled]="progress<100">
              <div class="d-flex text-black">
                <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="lock"></i-tabler><span class="f-s-14 text-white"> Finalise and Close</span>
              </div>
            </button>

            <button mat-flat-button color="primary" class="bg-success rounded-5 m-l-16" (click)="FinaliseandSubmitAccounts()" [disabled]="progress<100">
              <div class="d-flex text-black">
                <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Finalise and Submit Accounts</span>
              </div>
            </button>
            <!--<button mat-flat-button color="primary" class="bg-success rounded-5" (click)="save()">
              <div class="d-flex text-black">
                <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save</span>
              </div>
            </button>-->
          </div>
        </div>
      </div>
      <div class="card p-y-0 m-t-20">
        <div class="row" *ngIf="apFinalised">
          <div class="col-lg-6">
            <p class="f-s-14 f-w-500 m-0 p-0">
              Ready to Finalise: <span *ngIf="progress>=100"> Yes</span><span *ngIf="progress<100"> No</span>
            </p>
          </div>
          <!--&& !UserRoleAccess?.m1Create future condition-->
          <div class="col-lg-6 text-right">
            <button mat-flat-button class="rounded-5" style="border: 1px solid #fdba74; background:#fff;" (click)="UnfreezeAP()">
              <div class="d-flex text-black">
                <i-tabler class="icon-20 m-r-4 m-t-0" name="lock-open" style="color: #c2410c;"></i-tabler><span class="f-s-14" style="color: #c2410c;">Unlock</span>
              </div>
            </button>

            <!--<button mat-flat-button color="primary" class="bg-success rounded-5 m-l-16" (click)="FinaliseandSubmitAccounts()" [disabled]="progress<100">
              <div class="d-flex text-black">
                <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Finalise and Submit Accounts</span>
              </div>
            </button>-->
            <!--<button mat-flat-button color="primary" class="bg-success rounded-5" (click)="save()">
              <div class="d-flex text-black">
                <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save</span>
              </div>
            </button>-->
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>


<ng-template #template>
  <div class="m-20">
    <div class="b-b-1 p-b-10">
      <div class="d-flex justify-content-between align-items-center p-x-10">
        <div>
          <mat-card-title class="mat-mdc-card-title">
            <h4 class="f-s-20 f-w-800 d-block m-b-0 heading p-l-8">
              Accounts Preview
            </h4>
            <!--<p class="f-s-14 f-w-400 m-y-4 p-l-8">
              Preview of Complete Accounts Package
            </p>-->
          </mat-card-title>
        </div>
        <div class="d-flex">
          <div>
            <button mat-flat-button color="primary" style="height: 30px;" (click)="ExportasPDFandIXBRL('ExportasIXBRL','Spinnerthree')" [disabled]="!UserRoleAccess?.m1ExportorDownload">
              <div class="d-flex align-items-center no-wrap">
                <i-tabler class="icon-18 m-r-10" name="printer"></i-tabler> Export iXBRL
              </div>
            </button>
          </div>
          <button class="text-center btn-close-dialog" (click)="closeModalPreview()" style="transform: scale(0.8); padding-top: 2px;">
            <i-tabler name="X" class=""></i-tabler>
          </button>
        </div>
      </div>
    </div>
    <!-- PDF Viewer -->
    <div class="row" style="margin-left: 0; margin-right: 0;">
      <div class="col-lg-12" style="height:900px;">
        <ng2-pdfjs-viewer #pdfViewerAutoLoad [zoom]="100.0"></ng2-pdfjs-viewer>
      </div>
    </div>
    <div class="row b-t-1 p-t-12">
      <!--<div class="col-lg-12 text-right">
        <button mat-flat-button color="primary" style="height: 30px;" [disabled]="!UserRoleAccess?.m1ExportorDownload">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-10" name="printer"></i-tabler> Print
          </div>
        </button>
      </div>-->
    </div>
  </div>
  <!-- Spinner overlay -->
  <div class="spinner-container" *ngIf="ShowSpinner3">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>


<!--<ng-template #modal>
<mat-card>
  <mat-card-content class="p-20">-->
<!-- Header Row with Matching Padding -->
<!--<div class="row mb-3" style="margin-left: 0; margin-right: 0;">
        <div class="col d-flex justify-content-between align-items-center">
          <b><span>Trustee List Report</span></b>
          <button class="btn-close-dialog" mat-dialog-close>
            <i-tabler name="X"></i-tabler>
          </button>
        </div>
      </div>


    </mat-card-content>
  </mat-card>
</ng-template>-->












<ng-template #templateExport>
  <div class="m-20">
    <div class="b-b-1 p-b-10">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <mat-card-title class="mat-mdc-card-title">
            <h4 class="f-s-16 f-w-600 d-block m-b-0 heading">
              Export Accounts
            </h4>
            <p class="f-s-14 f-w-400 m-y-0">
              Select the Sections to Include in Your Export File.
            </p>
          </mat-card-title>
        </div>
        <div>
          <button class="text-center btn-close-dialog" style="transform:scale(0.8)" (click)="closeModalPreview()">
            <i-tabler name="X" class=""></i-tabler>
          </button>
        </div>
      </div>
    </div>

    <form [formGroup]="exportForm">
      <mat-card class="w-100 shadow-none" style="margin-bottom: 0px !important;">
        <mat-card-content class="p-y-4">
          <div class="row card-row p-b-16">
            <div class="col-lg-12">
              <h5 class="f-s-16 f-w-600 heading-text-clr">Include in Export</h5>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1">
            <div class="col-lg-12">
              <mat-checkbox [checked]="selectAll" (change)="toggleAll($event)">Select All</mat-checkbox>
            </div>
          </div>

          <div class="row card-row p-y-4 b-t-1">
            <div class="col-lg-12">
              <mat-checkbox formControlName="coverPage">Cover Page</mat-checkbox>
            </div>
          </div>

          <div class="row card-row p-y-4 b-t-1">
            <div class="col-lg-12">
              <mat-checkbox formControlName="contentsPage">Contents Page</mat-checkbox>
            </div>
          </div>

          <div class="row card-row p-y-4 b-t-1">
            <div class="col-lg-12">
              <mat-checkbox formControlName="referenceandAdministrationDetails">Reference and Administration Details</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="TrusteeAnnualReportStatus=='Completed'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="trusteesAnnualReport">Trustees' Annual Report</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="StatementofTrusteesResponsibility=='Completed'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="statementofTrusteesResponsibility">Statement of Trustees’ Responsibility </mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="report_Type == 'Independent Examiner'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="independentExaminersReport">Independent Examiner's Report</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="report_Type == 'Auditor'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="auditorsReport">Auditor's Report</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="accounting_Method =='Accruals (FRS 102 SORP)'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="statementOfFinancialActivities" (change)="selectionchange('SOFA')">Statement of Financial Activities</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="accounting_Method=='Accruals (FRS 102 SORP)'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="balanceSheet" [disabled]="BalanceSheetStatus=='Incompleted'" (change)="selectionchange('BAL')">Balance Sheet</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="accounting_Method =='Cash (Receipts & Payments)'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="receiptsandPayments" (change)="selectionchange('RP')">Receipts and Payments</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="accounting_Method=='Cash (Receipts & Payments)'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="statementofAssetsandLiabilities" (change)="selectionchange('SFAL')">Statement of Assets and Liabilities</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1">
            <div class="col-lg-12">
              <mat-checkbox formControlName="notes">Notes</mat-checkbox>
            </div>
          </div>
          <!--<div class="row card-row p-y-4 b-t-1">
            <div class="col-lg-12">
              <mat-checkbox formControlName="directorsReport">Director's Report</mat-checkbox>
            </div>
          </div>-->
        </mat-card-content>
      </mat-card>
    </form>

    <div class="row b-t-1 p-t-12">
      <div class="col-lg-12 text-right">
        <button mat-flat-button class="btn-export-pdf m-r-10" style="height: 30px;" (click)="ExportasPDFandIXBRL('ExportasPDF','')" [disabled]="!UserRoleAccess?.m1ExportorDownload || !isAnySectionSelected()">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-4 text-dark" name="upload"></i-tabler> Export PDF
          </div>
        </button>
        <button mat-flat-button color="primary" class="mT-10" style="height: 30px;" (click)="ExportasPDFandIXBRL('ExportasIXBRL','')" [disabled]="!UserRoleAccess?.m1ExportorDownload || !isAnySectionSelected()">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-4 text-dark" name="upload"></i-tabler> Export iXBRL
          </div>
        </button>
      </div>
    </div>

  </div>
  <div class="spinner-container" *ngIf="ShowSpinner">
    <mat-spinner style="z-index:2000 !important;"></mat-spinner>
  </div>
</ng-template>

<div class="spinner-container" *ngIf="ShowSpinnerTwo">
  <mat-spinner style="z-index:2000 !important;"></mat-spinner>
</div>

<ng-template #emailtemplate>
  <mat-card style="margin-bottom: 0px !important;">
    <mat-card-content class="p-14 p-b-0">
      <!-- Header Row with Matching Padding -->
      <div class="row mb-3" style="margin-left: 0; margin-right: 0;">
        <div class="col d-flex justify-content-between align-items-center">
          <b><span>Send Mail</span></b>
          <button class="btn-close-dialog" (click)="cenceltemplate()">
            <i-tabler name="X"></i-tabler>
          </button>
        </div>
      </div>

      <!-- PDF Viewer -->
      <div class="row" style="margin-left: 0; margin-right: 0;" [formGroup]="Accountsform">
        <div class="col-lg-12">
          <div class="p-y-16 b-t-1" style="overflow: hidden;">

            <div class="col-lg-12" style=" padding: 20px; border-radius: 10px;">
              <div class="row align-items-center m-b-8">
                <div class="col-md-10">
                  <div class="d-flex align-items-center">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 82px;">From</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" maxlength="40" formControlName="from" value="example@mail.com" [disabled]="true" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row align-items-center m-b-8">
                <div class="col-md-10">
                  <div class="d-flex align-items-center">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 82px;">To</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" maxlength="100" formControlName="to" value="example@mail.com" />
                      <mat-error *ngIf="Accountsform.get('to')?.hasError('required')">
                        Email is required
                      </mat-error>
                      <mat-error *ngIf="Accountsform.get('to')?.hasError('pattern')">
                        Enter a valid Email
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="d-flex align-items-center mb-0">
                    <mat-checkbox class="example-margin" (change)="AccountsformmailtoCC()" formControlName="ccCheckbox"></mat-checkbox>
                    <label class="f-s-14 f-w-600 m-0 p-0">CC/BCC</label>
                  </div>
                </div>
              </div>
              <div class="row mt-2" *ngIf="ifCCorBCCAccountsform">
                <div class="col-md-6">
                  <div class="d-flex align-items-center m-b-8">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 88px;">CC</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" value="example@mail.com" formControlName="cc" maxlength="100" />
                      <mat-error *ngIf="Accountsform.get('cc')?.hasError('pattern')">
                        Enter a valid Email
                      </mat-error>

                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex align-items-center m-b-8">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 88px;">BCC</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" value="example@mail.com" formControlName="bcc" maxlength="100" />
                      <mat-error *ngIf="Accountsform.get('bcc')?.hasError('pattern')">
                        Enter a valid Email
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <div class="d-flex align-items-center m-b-8">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 82px;">Subject</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" value="Welcome to Charity Accounts Software" formControlName="subject" />
                      <mat-error *ngIf="Accountsform.get('subject')?.hasError('required')">
                        Subject is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <mat-card-content class="m-t-14 p-x-0">
              <div class="local-editor NgxEditor__Wrapper" style="height: 300px;">
                <ngx-editor-menu [editor]="editor1" [toolbar]="toolbar" [disabled]="apFinalised" class=""> </ngx-editor-menu>
                <ngx-editor [editor]="editor1" [disabled]="apFinalised" [placeholder]="'Type here...'" formControlName="Body"></ngx-editor>
              </div>
            </mat-card-content>

            <hr class="m-t-24" style="opacity:0.2" />
            <div class="row p-t-16 p-b-0">
              <div class="col-sm-12 col-md-12 text-right">
                <button mat-flat-button type="submit" color="primary" class="bg-success rounded-5 m-r-10" (click)="sendmail()" [disabled]="isBodyEmpty(Accountsform)">
                  <div class="d-flex">
                    <span class="f-s-14 text-dark"> Send </span>
                  </div>
                </button>
                <button mat-flat-button color="primary" class="bg-white border-light b-1 text-end m-r-10" (click)="cenceltemplate()">
                  <div class="d-flex text-black">
                    <span class="f-s-12 text-black"> Cancel </span>
                  </div>
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
<ng-template #template2>

  <div [formGroup]="CharityTrusteesFrom" validateOnTouch>
    <div class="bg-light p-y-10 p-x-24">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <mat-card-title class="mat-mdc-card-title d-flex gap-10 align-items-center">
            <h4 class="f-s-16 f-w-600 d-block m-b-0 heading">Add New Trustee</h4>
          </mat-card-title>
        </div>
        <div>
          <button class="text-center btn-close-dialog" (click)="closeTrusteee()">
            <i-tabler name="X" class="con-20 m-r-2"></i-tabler>
          </button>
        </div>
      </div>
    </div>

    <div mat-dialog-content class="m-t-0 p-x-16">
      <div class="col-md-12 col-lg-12">
        <div class="row">
          <div class="col-sm-12 d-flex align-items-center">
            <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Trustee Name <span class="text-danger"> *</span></mat-label>
          </div>
          <div class="col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <input matInput placeholder="Trustee Name" appInputRestriction='CompanyName' appTrim formControlName="name" maxlength="50" />
              <mat-error *ngIf="CharityTrusteesFrom.get('name')?.hasError('required') ">
                Trustee Name is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-12">
        <div class="row">
          <div class="col-sm-12 d-flex align-items-center">
            <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Date of Appointment <span class="text-danger"> *</span></mat-label>
          </div>
          <div class="col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <input matInput [matDatepicker]="picker" placeholder="dd/mm/yyyy" appTextMaskDate formControlName="date_of_appointment" (blur)="vldtrusteedateofapp($event)" (dateChange)="vldtrusteedateofapp($event)" />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="CharityTrusteesFrom.get('date_of_appointment')?.hasError('required') ">
                Date of Appointment is required
              </mat-error>
              <mat-error *ngIf="CharityTrusteesFrom.get('date_of_appointment')?.hasError('invalid') ">
                Date of Appointment is invalid
              </mat-error>
              <mat-error *ngIf="CharityTrusteesFrom.get('date_of_appointment')?.hasError('date') ">
                Date of Appointment cannot be more than today's date
              </mat-error>
              <mat-error *ngIf="CharityTrusteesFrom.get('date_of_appointment')?.hasError('Removaldate') ">
                Date of Appointment cannot be more than Charity Removal Date
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-12">
        <div class="row">
          <section class="example-section">
            <mat-checkbox class="example-margin p-l-4 p-r-0" (change)="showChairOfBoard()" formControlName="is_chair">Chair of the Board</mat-checkbox>
          </section>
        </div>
      </div>
    </div>
    <!--<div class="row b-t-1 m-t-20 p-t-20" *ngIf="chairOfBoardOptions">-->
    <div class="m-t-0 p-x-16" *ngIf="chairOfBoardOptions">
      <div class="col-md-12 col-lg-12">
        <div class="row">
          <div class="col-sm-12 d-flex align-items-center">
            <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Charity Name <span class="text-danger"> *</span></mat-label>
          </div>
          <div class="col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <input matInput placeholder="Charity Name" appInputRestriction='CompanyName' appTrim formControlName="charity_name" />
              <mat-error *ngIf=" CharityTrusteesFrom.get('charity_name').hasError('required') && CharityTrusteesFrom.get('charity_name').invalid">
                Charity Name is required
              </mat-error>
              <mat-error *ngIf="CharityTrusteesFrom.get('charity_name').touched && CharityTrusteesFrom.get('charity_name').hasError('pattern')">
                Only alphanumeric characters allowed
              </mat-error>
              <mat-error *ngIf=" CharityTrusteesFrom.get('charity_name').hasError('minlength')">
                Charity Name  should be minimum 3 characters
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-12">
        <div class="row">
          <div class="col-sm-12 d-flex align-items-center">
            <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Charity Number <span class="text-danger"> *</span></mat-label>
          </div>
          <div class="col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <input matInput placeholder="Charity Number" appInputRestriction="numericOnly" (keypress)="restrictInput($event)" maxlength="8" formControlName="reg_charity_number" (input)="validateNew($event)" />
              <mat-error *ngIf="CharityTrusteesFrom.get('reg_charity_number').invalid && CharityTrusteesFrom.get('reg_charity_number').hasError('required')">
                Charity Number is required
              </mat-error>
              <mat-error *ngIf="CharityTrusteesFrom.get('reg_charity_number').hasError('duplicate') && CharityTrusteesFrom.get('reg_charity_number').invalid">
                Charity Number already exists
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-12">
        <div class="row">
          <div class="col-sm-12 d-flex align-items-center">
            <mat-label class="f-s-14 f-w-600 d-block m-b-0 heading">Reporting Status <span class="text-danger"> *</span></mat-label>
          </div>
          <div class="col-sm-12">
            <mat-form-field appearance="outline" class="w-100 m-t-8">
              <mat-select placeholder="Select Reporting Status" formControlName="reporting_status">
                <mat-option value="New">New</mat-option>
                <mat-option value="Removed">Removed</mat-option>
                <mat-option value="Submission Double Default">Submission Double Default</mat-option>
                <mat-option value="Submission Overdue">Submission Overdue</mat-option>
                <mat-option value="Submission Received">Submission Received</mat-option>
                <mat-option value="Submission Received Late">Submission Received Late</mat-option>
                <mat-option value="Suppressed">Suppressed</mat-option>
              </mat-select>
              <mat-error *ngIf="CharityTrusteesFrom.get('reporting_status')?.hasError('required') ">
                Select a Reporting Status
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="justify-content-end d-flex m-t-10 bg-light p-y-14 p-x-24">
      <button mat-flat-button color="primary m-r-10" (click)="saveTrustee(undefined,'true')" [disabled]="onFirstClick || !UserRoleAccess?.m1Add">
        <div class="d-flex align-items-center">
          <span class="f-s-14">Save</span>
        </div>
      </button>
      <button mat-flat-button class="bg-error" (click)="closeTrusteee()">
        <div class="d-flex align-items-center border-radius-0 ">
          <span class="f-s-14">Cancel</span>
        </div>
      </button>

    </div>
  </div>
</ng-template>

<div class="spinner-container" *ngIf="loading">
  <img src="../../../../assets/images/backgrounds/acct-loading2.gif" />
</div>
